function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "280",
  height: "256",
  viewBox: "0 0 280 256",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h280v256H0z"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M166.1 193c.4 2.6.5 5.3.5 7.9 0 11.8-3.6 22.8-9.8 32H177c4.6-9.7 7.2-20.5 7.2-32 0-3.4-.2-6.9-.7-10.3-1.3-9.1-4.2-17.7-8.4-25.4h-21c6.3 7.8 10.5 17.3 12 27.8z",
  fill: "#797673"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.5 163.2l-58.1 19.1-5.5-27.6 59.2-13.1 4.4 21.6z",
  fill: "url(#paint0_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.4 158.6l-58.3 17.8-1-4.7L90.4 154l1 4.6zM91.1 151.5l-59 14.4-.8-4.7 59-14.5.8 4.8z",
  fill: "#C8C6C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M262.9 163.3h-6.8V256h6.8v-92.7z",
  fill: "#797673"
}), /*#__PURE__*/React.createElement("path", {
  d: "M266.7 198.5h-14.4c-2.4 0-4.4-2-4.4-4.4v-29.5c0-2.4 2-4.4 4.4-4.4h14.4c2.4 0 4.4 2 4.4 4.4v29.5c0 2.4-2 4.4-4.4 4.4z",
  fill: "#C7E2F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M261.7 182.7h-4.4c-1.5 0-2.8-1.3-2.8-2.8v-11c0-1.5 1.3-2.8 2.8-2.8h4.4c1.5 0 2.8 1.3 2.8 2.8v11c0 1.6-1.3 2.8-2.8 2.8z",
  fill: "#E1DFDD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.5 170.6v7.7",
  stroke: "#797673",
  strokeWidth: "2.035",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.4 191.9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM263.5 191.9a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
  fill: "#3686C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M262.9 255.9H85.5v-1.1c0-22.8 18.5-41.4 41.4-41.4h94.6c22.8 0 41.4 18.5 41.4 41.4v1.1z",
  fill: "#C8C6C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.5 254.8v1.1h177.4v-1.1c0-5.2-1-10.2-2.7-14.7h-172c-1.7 4.5-2.7 9.5-2.7 14.7z",
  fill: "#B3AFAB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.1 40c-3.2 1.6-21.2-1.2-18.4-3.4 3-2.3 4.1-8 3.7-13.2-.4-4.2-.5-7-.5-7l17.5-.1c0 .1 3.2 20.9-2.3 23.7z",
  fill: "#FADCBD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.4 99.2l-47.2-11.1 2.1-35c.7-11.4 8.9-22.3 20.6-22.7 17.3-.5 27.6 13.9 26.7 32.5l-2.2 36.3z",
  fill: "#B3AFAB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.8 19.7l20.1-2.8-1.5-10.8c-.1-.5-.5-.8-1-.7l-13.6 1.9c-3.1.4-5.3 3.3-4.8 6.4l.8 6z",
  fill: "#E0BB95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.7 18.7l.7 4.7s1.5.1 2.4-.8c.8-.8.8-2.3.1-3.4-1-1.6-3.2-.5-3.2-.5z",
  fill: "#E0BB95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.8 20.2a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
  fill: "#FADCBD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.2 29.7c4.4.1 6.2-2.2 6.6-4.3.3-2.1-.8-4.5-1.7-6.5-.8-1.7-1.1-3.4-1.6-6.6-.6-4.1-3.4-5.1-7-5.1-.6 0-1.5.2-2.1.4-3.4 1.1-5.5 3.3-5 7.1.2 2.3.6 5.4 1.2 7.7 1.1 5.2 4.4 7.1 9.6 7.3z",
  fill: "#E0BB95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.5 21.1l5.4-.8-1.8-12.6-5.4.8c-2.5.4-4.3 2.7-3.9 5.2l.5 3.4c.3 2.6 2.6 4.4 5.2 4z",
  fill: "#FADCBD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.2 8.3c-2.8-.4-5.7-.1-8.5.1-4.3.3-7.7 1.4-7.7 1.4l-.1-1.3c-.2-3 1.3-6 4.8-5.8 5.5.2 4.2-1.3 6.5-1.7 2.2-.4 2.9 1.8 3.8 1.7 2.3-.2 1.5-2.5 5-2.7 3.6-.2 6.4 9.7-3.8 8.3z",
  fill: "#E0BB95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.4 17.1c.1 1.2 1.2 2.1 2.4 2 1.3-.1 2.2-1.1 2-2.5-.2-1.3-1.3-1.9-2.2-1.8h-.5c-.7.1-1.9.6-1.7 2.3z",
  fill: "#FADCBD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.2 22.7l-3.7.5c-1 .1-1.8-.5-2-1.5v-.2c-.1-1 .5-1.8 1.5-2l3.7-.5.5 3.7z",
  fill: "#E0BB95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.6 20.6c-.2.5-.5.6-.8.6-.3 0 .8 1 .8 1l.7-1.2s-.7-.5-.7-.4z",
  fill: "#E0BB95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.7 16.3c0-.3 0-.6.2-.9.2-.3.5-.5.9-.6.4-.1.7 0 1 .1.3.2.5.4.6.7 0 .2-.1.3-.2.4H174.9c-.2-.1-.4-.1-.5-.1-.1 0-.3 0-.4.1-.1 0-.2.1-.3.1l-.4.4c-.2.1-.4.1-.5 0 0-.1-.1-.2-.1-.2z",
  fill: "#594539"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".7",
  d: "M174.6 20.6c.2.2.4.3.7.4.2.1.5.1.7.2.2 0 .5.1.7.1.2 0 .4 0 .7-.1h.1c.2-.1.4 0 .4.2v.2c-.1.4-.5.8-.9.9-.4.2-.8.2-1.2.1-.4-.1-.8-.3-1.1-.5-.3-.3-.5-.7-.5-1.1 0-.2.1-.3.3-.3 0-.2 0-.2.1-.1z",
  fill: "#BF8F68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3 79.6c3.2-2.4 5.2-.8 8.5-4.4 2.1-2.3-3.4-7.9.6-11.7 3.3-3.2 7 .1 9.5-2.5s-1-7.4 1.3-10.1c2.3-2.7 5.5-.9 8.3-3 3.6-2.7 2.9-8.1 2.9-9.5 4-1.5 24.5-4 28.7-1.9.6 3.6-9.2 11.4-7 14.5 2.2 3.1 5.3 4.2 7 7.8 1.6 3.6-2.7 7.6-1.7 11.4 1 3.8.2 24.9-18.4 22.9-7-.8-10.1 6.7-15.2 4.3-5.1-2.5-3.3-6.8-14.7-5.6-13 1.4-14.4-8.7-9.8-12.2z",
  fill: "#E0BB95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.3 45.7c.3.6.7 1.1 1.1 1.6 2.1 2.8 5 4.7 8.1 5.6 3.7 1.1 7.7.7 11.2-1.3l.2-.1c6.5-3.7 8.8-11.9 5.7-19-.2-.5-.5-1.1-.8-1.6-1.8-3.2-4.7-5.4-7.9-6.3-1.5-.5-3.2-.6-4.8-.5-1.7.2-3.4.7-4.9 1.6l-3.5 2c-1.6.9-2.9 2.2-3.9 3.6-2.9 4.2-3.2 9.7-.5 14.4z",
  fill: "#E0BB95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.645 46.057l-6.044 2.893 4.448 9.291 6.043-2.893-4.447-9.29z",
  fill: "#9B643D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136.165 39.104c.431-.249.443-1.032.028-1.75-.414-.716-1.099-1.096-1.53-.847-.43.249-.443 1.032-.028 1.749.415.717 1.1 1.097 1.53.848z",
  fill: "#33312D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.8 49.2l2.6-1.5c2.6-1.5 3.5-4.9 2-7.5l-8-13.8-14.3 8.3 6.7 11.6c2.2 3.8 7.1 5.1 11 2.9z",
  fill: "#9B643D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.5 38.6c-.1-.3-.1-.6 0-.9.1-.3.4-.6.7-.8.7-.4 1.5-.2 1.9.4.1.2 0 .4-.1.4H135.7c-.4 0-.7.1-.9.2-.2.1-.4.3-.6.7v.1c-.1.2-.3.2-.5.1-.1 0-.2-.1-.2-.2z",
  fill: "#33312D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.4 40c.3.5.8.6 1.3.6 1 0 1.9-.6 2.5-1.5.1-.1.5-.9 0-1.6-.4-.5-1.2-.6-1.2-.6-.8-.1-1.3-.2-2.1-1.1-.1 0-1.2 3.1-.5 4.2z",
  fill: "#9B643D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.1 29.4l-2.8 1.6c1.7 3.4.5 7.7-2.9 9.6l-4.3 2.5-.1 2.5-2.6 1.5-6.6-11.5 17.2-10 2.1 3.8z",
  fill: "#E0BB95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.4 31l2.8-1.6c-.5-.7-1.3-1.6-2.4-.9-1.2.6-.8 1.7-.4 2.5z",
  fill: "#BF8F68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.1 43.1c-1.6.9-2.2 2.9-1.3 4.4.9 1.5 2.8 2 4.4 1l-3.1-5.4zM87.7 31.1l-2.4-5.3c-.2-.5-.8-.9-1.4-.9h-2c-.5 0-1 .3-1.2.8l-.3.7-2.1.2c-.7.1-1.2.6-1.2 1.3 0 .5.3.9.7 1.1l.6.3.9 3.2c.2.8.8 1.4 1.6 1.5l5.3 1 3.4 1.8 1-3.2-2.9-2.5z",
  fill: "#9B643D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.1 96.8c-.9-1.7-2.1-3.2-3.5-4.5h.1l-3-3.6c-4-4.8-5.8-27.5-21.4-33-3.3-1.2-7.7-.3-11.3-.6-3.9-.4-7.2-2.3-7.2-2.3L87.7 31.1l-1.6 4.1s38.3 34 48.7 47c3 4.4 4.5 9.5 4.4 14.9l-.1 4.7h.1c-.3 1.9-.3 3.8.1 5.8.1 9.6 5.1 17.2 9.4 19.9 19.8 12.1 25.1-5.3 30.9-4.8-5-19.4-9.5-25.9-9.5-25.9z",
  fill: "#D83B01"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.5 42.4l3.3-.5c.2 0 .4.1.4.3 0 .7-.1 2.4-1.7 2.5-1.4.1-2-1.2-2.2-1.8-.2-.3 0-.5.2-.5z",
  fill: "#594539"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.5 42.4c-.1 0-.2.1-.3.2.2.1.5.2.7.2.8.1 2 .2 3.1-.9-.1 0-.1-.1-.2 0l-3.3.5z",
  fill: "#F3F2F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174 68.7l12.1-.6c2.2-.1 3.9-3.6 3.8-5.7l-.3-6c-.3-4.9-4.7-8.7-9.9-8.4l-1.4.1c-5.2.3-9.2 4.5-9 9.4l.3 6c.1 2.8 2.2 5.3 4.4 5.2z",
  fill: "#594539"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.1 84.6l-6.7-7.2 13.8-12.9 6.7 7.2-3.8 4.6s-1.3-1-2.6.3l-7.4 8z",
  fill: "#E0BB95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.3 77.1h-.8c-4.7.3-8.8-3.4-9-8.1l-.8-15.5 14.7-.8 1 18.7c.1 3.1-2.1 5.6-5.1 5.7z",
  fill: "#E0BB95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.6 70.4c.3-.2.8-.2 1.1-.2.4.1.7.2.9.3.3.1.5.2.6.3.1.1.3.2.6.2.2 0 .3.2.3.3v.1c-.1.4-.6.7-1.1.7-.5 0-.8-.1-1.1-.3-.6-.3-.9-.6-1.4-1-.1.1-.1-.1.1-.4-.1.1-.1.1 0 0z",
  fill: "#9B643D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.097 65.099c.441-.026.757-.763.705-1.645-.052-.882-.451-1.576-.893-1.55-.441.026-.756.762-.704 1.644.051.882.451 1.576.892 1.55z",
  fill: "#3A312E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.6 56a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4z",
  fill: "#594539"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.6 63.1l5.1-.3c2-.1 3.5-1.8 3.4-3.8 0 0-.1-1.3-.1-2.6s2.5-3.2 2.5-3.2l-11.3.5.4 9.4z",
  fill: "#594539"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.1 69.7l-1.1.1s.2-6.5.9-7.5c.3 1.4 1.7 2.5 1.7 2.5.8.7 1.2 1.8 1 2.8-.2 1-1 1.8-2.1 2-.1.1-.2.1-.4.1zM175.5 69.3h-.5c-1.8.1-3.3-1.3-3.3-3-.1-1.8 1.3-3.3 3-3.3h.5c1.8-.1 3.3 1.3 3.3 3 .1 1.7-1.2 3.2-3 3.3z",
  fill: "#E0BB95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.3 55.8l-8.9.5c-1.9.1-3.3 1.7-3.2 3.5l.4 7.1c-.2-3.4-3.1-6-6.5-5.8-3.4.2-6 3.1-5.9 6.5.1 2.7 2 4.9 4.5 5.6-6.1-1.4-10.9-6.8-11.2-13.4-.2-4 1.2-7.7 3.7-10.5s6-4.6 10-4.8l2.2-.1c7.2-.3 13.4 4.6 14.9 11.4z",
  fill: "#FCFBFB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.1 61.1c3.4-.2 6.3 2.4 6.5 5.8.2 3.4-2.4 6.3-5.8 6.5h-.9-.1c-.3-.1-.7-.1-1.1-.2-2.5-.7-4.3-2.9-4.5-5.6-.2-3.4 2.5-6.3 5.9-6.5z",
  fill: "#FCFBFB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.4 74.6c-.9 0-2.9-.1-4.7-1.2-.5-.3-.7-1-.4-1.5.3-.5 1-.7 1.5-.4 1.6 1 3.7.8 3.8.8 1.4-.1 2.6-.7 3.5-1.7.9-1 1.4-2.3 1.3-3.7l-.4-7.1c-.1-1.2.3-2.3 1.1-3.2.8-.9 1.9-1.4 3.1-1.5l8.9-.5c.6 0 1.1.4 1.2 1.1 0 .6-.4 1.1-1.1 1.2l-8.9.5c-.6 0-1.1.3-1.5.7-.4.4-.6 1-.6 1.6l.4 7.1c.1 1.9-.6 3.8-1.9 5.3-1.3 1.5-3.1 2.3-5 2.4.1.1-.1.1-.3.1z",
  fill: "#E1E0DE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.1 71.2s-16.5 4.5-15.5 35.3c.5 15.2 1.3 24.3 1.3 24.3l29.9-1.7s-1.2-22.7-1.9-36.1c-.7-13.4-4.1-18.5-4.1-18.5l-9.7-3.3z",
  fill: "url(#paint1_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.2 113c-10.7-4.4.4-35.6.4-35.6.9-4.6 5.4-7.5 10-6.6 4.6.9 7.4 4.6 5.3 12.5-.7 2.8-5 10.6-5.7 14.6-1 6.3-2.1 14.7-10 15.1z",
  fill: "#2B88D8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.7 137.3c-4.9 0-8.9-4-8.9-8.9V95c0-4.9 4-8.9 8.9-8.9s8.9 4 8.9 8.9v33.4c0 4.9-4 8.9-8.9 8.9z",
  fill: "#33312D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.5 89.7l-29.8 47.6 39.9.6-10.1-48.2z",
  fill: "#33312D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193 106.3c-1.1-.3-1.7-1.3-1.4-2.4L197 82c.3-1.1 1.3-1.7 2.4-1.4 1.1.3 1.7 1.3 1.4 2.4l-5.4 21.9c-.3 1.1-1.3 1.7-2.4 1.4z",
  fill: "#2B88D8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.4 95.2l1.3-3.6c.4-1 1.1-1.9 2-2.5l1.8-1.2-.6 2.6 4-.7c.6 0 1.2.5 1.2 1.1 0 .5-.4 1-.9 1l-.4.1c.3.7.4 1.4.1 2.1l-.6 1.7c-.3.9-1 1.6-1.9 1.9l-4.4 1.8-2 1.3-1.6-3.3 2-2.3z",
  fill: "#E0BB95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.4 95.2l-21.2 2.7s-18.1 4.8-10 15.1c8.4 2.6 32.7-13.3 32.7-13.3l-1.5-4.5z",
  fill: "#2B88D8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2 156.8l74.6-15.6c-14.5-31.9-54.6-50-96.8-41.6 10.8 9.4 18.4 21.7 21.4 35.9 1.5 7.1 1.7 14.3.8 21.3z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2 156.8l74.6-15.6c-.4 35-30 67.7-71.9 77 6.1-13 8.2-27.3 5.2-41.5-1.5-7.2-4.2-13.9-7.9-19.9z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M280 114.5c-7.9 26-51.6 53.3-108 65.1-36.1 7.6-70 7.2-94.3.6l-9.4-44.6c16.2-13.1 40-24.8 68.1-32.8 4.9 15.8 21.1 25.6 37.6 22.1 15.5-3.2 26-17 25.8-32.2 37.2-1.2 67.4 6.8 80.2 21.8z",
  fill: "#E1DFDD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.1 127.2c-4.2 2.7-8.2 5.5-11.7 8.4l9.4 44.6c4.4 1.2 9.1 2.2 14.1 3l-11.8-56z",
  fill: "url(#paint4_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M245.8 96.7l10 47.8c12.6-9.5 21.1-19.9 24.2-30-6.9-8.1-18.9-14.1-34.2-17.8zM136.6 144.6c.6 2.8-9.3 7.3-33 12.2-23.7 4.9-43.8 3.9-43.8 3.9s18.1-9.1 41.7-14.1 34.5-4.9 35.1-2z",
  fill: "#3686C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200 92.7c.2 15.2-10.3 28.9-25.8 32.2-16.4 3.4-32.6-6.2-37.6-21.9",
  stroke: "#B3AFAB",
  strokeWidth: "5.851",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.4 168.7c7.07 0 12.8-5.731 12.8-12.8 0-7.069-5.73-12.8-12.8-12.8s-12.8 5.731-12.8 12.8c0 7.069 5.73 12.8 12.8 12.8z",
  fill: "#E1DFDD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1 174.5c8.34 0 15.1-6.761 15.1-15.1 0-8.34-6.76-15.1-15.1-15.1S0 151.06 0 159.4c0 8.339 6.76 15.1 15.1 15.1z",
  fill: "#E1DFDD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 191.8c7.07 0 12.8-5.731 12.8-12.8 0-7.069-5.73-12.8-12.8-12.8s-12.8 5.731-12.8 12.8c0 7.069 5.73 12.8 12.8 12.8z",
  fill: "#E1DFDD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.3 195c7.07 0 12.8-5.731 12.8-12.8 0-7.069-5.73-12.8-12.8-12.8s-12.8 5.731-12.8 12.8c0 7.069 5.73 12.8 12.8 12.8z",
  fill: "#E1DFDD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 208.7c5.633 0 10.2-4.567 10.2-10.2 0-5.633-4.567-10.2-10.2-10.2-5.633 0-10.2 4.567-10.2 10.2 0 5.633 4.567 10.2 10.2 10.2zM25.5 149.6c5.689 0 10.3-4.611 10.3-10.3 0-5.689-4.611-10.3-10.3-10.3-5.689 0-10.3 4.611-10.3 10.3 0 5.689 4.611 10.3 10.3 10.3z",
  fill: "#E1DFDD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.7 236.1a8.8 8.8 0 100-17.6 8.8 8.8 0 000 17.6z",
  fill: "#C7E2F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.5 227.3s0 .1 0 0c3.9 1.3 6.3 2.6 6.2 3.3-.3 1.2-7.1.6-15.4-1.2-8.2-1.8-14.7-4.3-14.4-5.4.2-.7 2.9-.8 6.9-.3v-.1c-6.4-.9-10.9-.9-11.2.3-.4 1.6 7.8 4.9 18.3 7.2s19.3 2.9 19.6 1.3c.3-1.2-3.8-3.2-10-5.1zM175.8 222.7c-.4 1.2-1.1 2.2-2.1 2.9-.2.1-.2.4 0 .5 1 .8 1.7 1.9 2.1 3.1.1.3.5.3.6 0 .4-1.2 1.1-2.3 2.1-3.1.2-.1.1-.4 0-.5-1-.7-1.7-1.7-2.1-2.9-.1-.3-.5-.3-.6 0zM167.1 228c-.3.9-.8 1.6-1.5 2.1-.1.1-.1.3 0 .4.7.6 1.2 1.4 1.5 2.3.1.2.4.2.5 0 .3-.9.8-1.7 1.5-2.3.1-.1.1-.3 0-.4-.7-.5-1.2-1.3-1.5-2.1-.1-.2-.4-.2-.5 0zM231.7 223.3c-.3.9-.9 1.7-1.6 2.3-.1.1-.1.3 0 .4.8.7 1.3 1.5 1.7 2.5.1.2.4.2.5 0 .3-1 .9-1.8 1.7-2.5.1-.1.1-.3 0-.4-.8-.6-1.3-1.4-1.6-2.3-.3-.2-.6-.2-.7 0z",
  fill: "#F3F2F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.6 51.7l1.4-.7c-.4-.9-.1-2 .8-2.5l-3.4-2.2 1.2 5.4zM127.1 47.2l-1 1.7c1-.2 1.8.5 2 1.1l1.2-.8-2.2-2z",
  fill: "#9B643D"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(37.1654 -.46504 .54377 43.4568 24.253 174.306)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C8C6C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#E1DFDD"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(-3.045 2240.995 -3248.291) scale(41.3486)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#106EBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".779",
  stopColor: "#2B88D8"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(80.108 155.203) scale(21.1503)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#106EBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#2B88D8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: "130.345",
  y1: "175.065",
  x2: "82.784",
  y2: "90.78",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#106EBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".368",
  stopColor: "#1472C2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".758",
  stopColor: "#217ECE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".967",
  stopColor: "#2B88D8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: "120.633",
  y1: "132.23",
  x2: "102.418",
  y2: "204.558",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#106EBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".405",
  stopColor: "#1876C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".967",
  stopColor: "#2B88D8"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h280v256H0z"
})))));